import { render, staticRenderFns } from "./FinanceDetails.vue?vue&type=template&id=129f6420&scoped=true&"
import script from "./FinanceDetails.vue?vue&type=script&lang=js&"
export * from "./FinanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDetails.vue?vue&type=style&index=0&id=129f6420&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f6420",
  null
  
)

export default component.exports